import { render, staticRenderFns } from "./submitorder.vue?vue&type=template&id=2363555b&scoped=true&"
import script from "./submitorder.vue?vue&type=script&lang=js&"
export * from "./submitorder.vue?vue&type=script&lang=js&"
import style0 from "./submitorder.vue?vue&type=style&index=0&id=2363555b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2363555b",
  null
  
)

export default component.exports